let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dQNjw")).then(() => parcelRequire('9mwnp'));